var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 39,
    viewBox: "0 0 42 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95313 0C7.63828 0 6.5625 1.07718 6.5625 2.39374V35.9061C6.5625 37.2227 7.63828 38.2998 8.95313 38.2998H32.8594C34.1742 38.2998 35.25 37.2227 35.25 35.9061V9.57496L25.6875 0H8.95313Z",
    fill: "#3CB4E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0781 9.57497H35.25L25.6875 0V7.18122C25.6875 8.49778 26.7633 9.57497 28.0781 9.57497Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 17.0625,
    width: 42,
    height: 18.375,
    rx: 2,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileLogo);
export default __webpack_public_path__ + "static/media/fileLogo.2ec0f0b6ed573d0a933a9e4be61d941c.svg";
export { ForwardRef as ReactComponent };